export enum GROUP_FUNCTION {
  NONE = "...",
  GROUP = "Group",
  COUNT = "Count",
  SUM = "Sum",
  MAX = "Maximum",
  GROUP_BY_MONTH = "Group By Month",
  COUNT_DISTINCT = "Count Distinct",
}